var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceipt = function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 24 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22 2.666-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2v18.667H0v4c0 2.213 1.787 4 4 4h16c2.213 0 4-1.787 4-4V.666zm-.667 20.667c0 .733-.6 1.333-1.333 1.333s-1.333-.6-1.333-1.333v-4h-12V4.666h14.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 7.332H8v2.667h8zM20 7.332h-2.666v2.667h2.667zM16 11.332H8v2.667h8zM20 11.332h-2.666v2.667h2.667z"
  })));
};
export default SvgReceipt;